// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"976acb56","166":"184ab13e","198":"6305ec3e","498":"9491e08d","611":"fbefd455","703":"940b5f3b","706":"ff127f8d","944":"99d1b437"}[chunkId] + ".chunk.js";
};